import React, { useCallback, useEffect, useRef } from 'react';
import gsap from 'gsap/all';
import {useTranslation} from 'react-i18next';
import { useAnimationContext } from '../../context/AnimationContext';
import { useAudioContext } from '../../context/AudioContext';
import { useNavigationContext } from '../../context/NavigationContext';
import { SectionIDs } from '../../data/Sections';
import Button from '../../elements/Button';
import BasePageProps from '../view2D/BasePageProps';
import BaseSection from '../view2D/BaseSection';
import styles from './styles.module.scss';
import useIsMobile from '../../hooks/useIsMobile';

const containerStyle: React.CSSProperties = {
  height: '100%'
};

function TitlePage({ ...props }: BasePageProps): JSX.Element
{
  const {t} = useTranslation('ai4Jokes');
  const { enableAudio, playAudio } = useAudioContext();
  const { AddAnimations } = useAnimationContext();
  const { activeSectionID, moveToTheSection } = useNavigationContext();

  const itsNoJokeRef = useRef<HTMLDivElement>(null);
  const teachingAIRef1 = useRef<HTMLDivElement>(null);
  const teachingAIRef2 = useRef<HTMLDivElement>(null);

  const isMobile = useIsMobile();

  const startTheExperience = useCallback(
    () => {
      enableAudio();
      playAudio('audioCTA');
      moveToTheSection(SectionIDs.Intro1);
    },
    [enableAudio, playAudio, moveToTheSection],
  );

  useEffect(() => {
    if(!isMobile)
      enableAudio();
  }, [isMobile, enableAudio]);

  useEffect(() =>
  {
    if(activeSectionID === SectionIDs.Title){
      gsap.fromTo(itsNoJokeRef.current, { bottom: '-3rem' }, { bottom: '3.5rem', duration: 0.3, delay: 0.1});
      gsap.fromTo(teachingAIRef1.current, { bottom: '-2rem' }, { bottom: '2.3rem', duration: 0.5, delay: 0.3});
      gsap.fromTo(teachingAIRef2.current, { bottom: '-2rem' }, { bottom: '2.3rem', duration: 0.5, delay: 0.3});
    }
  },
  [activeSectionID]);

  useEffect(() =>
  {
    AddAnimations([
      {
        targets: containerStyle,
        from: { height: '100%' },
        to: { height: '0vh' },
        start: 0.5,
        end: 1
      }
    ], props.sectionID);
  }, [ AddAnimations, props.sectionID ]);

  return <BaseSection {...props} style={{ position: 'fixed', height: '100%' }}>
    <div className={styles.container} style={{overflow: 'hidden', ...containerStyle}}>
      <div className={styles.background}>
        <div className={styles.innerContainer}>
          <div className={styles.upperTitle}>
            <h1 ref={itsNoJokeRef}>{t('itsnojoke.headline')}</h1>
          </div>
          <div className={styles.title}>
            <h4 ref={teachingAIRef1}>{t('itsnojoke.subheadline.1')}</h4>
          </div>
          <div className={styles.title} style={{marginBottom: '3rem'}}>
            <h4 ref={teachingAIRef2}>{t('itsnojoke.subheadline.2')}</h4>
          </div>
          <Button className={styles.button} click={startTheExperience}>
            Start
          </Button>
        </div>
      </div>
    </div>
  </BaseSection>;
}

export default React.memo(TitlePage);